import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { renderBuildResultMappingRenderer } from '@next-adapter/templates/renderers/generators/actions/action-helpers/build-result-mapping.js'
import { relationshipMappingExpression } from './relationship-mapping-expression.js'
import { relationshipRowType } from './relationship-row-type.js'
export function buildResultMapping(
  allDbFields: SchemaField[],
  relationshipFields: SchemaField[],
  Plural: string,
  camelPlural: string,
  Singular: string,
  hasListRels = false
): string {
  const relationshipDeclarations = relationshipFields
    .map(
      (f) => `      const ${f.name} = row.${f.name} as ${relationshipRowType(f)} | null | undefined`
    )
    .join('\n')
  const rowDeclarations = [
    relationshipDeclarations,
    `      const createdByUser = row.createdByUser as { id?: string | null; name?: string | null; email?: string | null } | null | undefined`,
    `      const updatedByUser = row.updatedByUser as { id?: string | null; name?: string | null; email?: string | null } | null | undefined`
  ]
    .filter(Boolean)
    .join('\n')

  const mappedTimestampFields = allDbFields.some((f) => f.name === 'createdAtFormatted')
    ? []
    : [
        `        createdAtFormatted: formatActionDate(row.createdAt)`,
        `        updatedAtFormatted: formatActionDate(row.updatedAt)`
      ]

  const rowMappings = allDbFields
    .map((f) => {
      if (f.type === 'relationship' && !f.multiple) {
        return `        ${f.name}: ${relationshipMappingExpression(f, f.name)}`
      }
      return `        ${f.name}: row.${f.name}`
    })
    .concat([
      ...mappedTimestampFields,
      `        createdByUser: createdByUser?.id ? { id: createdByUser.id, name: createdByUser.name ?? '', email: createdByUser.email ?? '' } : null`,
      `        updatedByUser: updatedByUser?.id ? { id: updatedByUser.id, name: updatedByUser.name ?? '', email: updatedByUser.email ?? '' } : null`
    ])
    .join(',\n')

  const mapBlock = renderBuildResultMappingRenderer({
    kind: 'renderBuildResultMappingResultTemplate',
    props: {
      plural: Plural,
      rowDeclarations: rowDeclarations,
      rowMappings: rowMappings
    }
  })

  if (hasListRels) {
    return renderBuildResultMappingRenderer({
      kind: 'renderBuildResultMappingResultDetailsTemplate',
      props: {
        mapBlock: mapBlock,
        plural: Plural,
        singular: Singular,
        camelPlural: camelPlural
      }
    })
  }

  return renderBuildResultMappingRenderer({
    kind: 'renderBuildResultMappingResultDetailsBranchTemplate',
    props: {
      mapBlock: mapBlock,
      camelPlural: camelPlural,
      plural: Plural,
      singular: Singular
    }
  })
}
